import { axiosRequest } from '../index';
import { FORGOT_PASSWORD, LOGOUT, SIGN_IN } from 'config/apis';
import { User } from 'types/auth';

export const AuthAPIs = {
  login: async (payload: any): Promise<User> => {
    const userData = await axiosRequest<User>(
      { method: 'POST', url: SIGN_IN, data: payload }
    );
    return userData;
  },

  forgotPassword: async (payload: any): Promise<void> => {
    await axiosRequest({ method: 'POST', url: FORGOT_PASSWORD, data: payload });
  },

  logout: async (): Promise<void> => {
    await axiosRequest({ method: 'POST', url: LOGOUT });
  },
};